import React from 'react';
import PropTypes from 'prop-types';

import {
    CardTitle,
    Row, Col,
} from 'reactstrap';

const moment = require('moment');

const ActionList = ({ actions }) => {
    if (typeof (actions) === 'undefined' || actions === null) {
        return null
    }

    if (actions.length < 1) {
        return null
    }
    return actions.map((action) => {
        return (
            <React.Fragment key={action.id}>
                <hr />
                <CardTitle className="ml-2 mt-1 mb-0">
                    <Row>
                        <Col xs="6" className="text-left">
                            <p><b> {action.remarker.name} </b></p>
                        </Col>
                        <Col xs="6" className="text-right">
                            <small>{moment(action.remarkedAt).format("YYYY/MM/DD hh:mm:ss A")}</small>
                        </Col>
                    </Row>
                </CardTitle>
                <div className="border-l-2 pl-2 ml-2 my-2">
                    {action.remark}
                </div>
            </React.Fragment>
        )
    })
};

ActionList.propTypes = {
    actions: PropTypes.array
};

export default ActionList;



// WEBPACK FOOTER //
// ./src/components/blocks/ActionList/ActionList.js